import React from 'react'
import '../../styles/projectDet.css';  
import BackButton from '../../components/UI/Scrolling/Back'
import aboutImg from '../../images/conjoint 2.png'
import projectImg from '../../images/Projects/project_5.png'

const Project_5 = () => {
  return (
    <section >
    <div className='container'>
    <BackButton />     

        <div className='about__wrapper'>
            <div >
            <div className='about__img'><img src = {projectImg}></img></div>                
                <h5 className='subtitle_services'>Development of a Comprehensive Conjoint Analysis Tool</h5>
                <br></br>
                

                <h2 className='subheader'>
                <p className='description about__content-desc'>
                BehaviouralStrategy LLC, based in Denmark, approached our team with a goal of automating the choice-based conjoint study design and analysis process. 
                This was aimed at making the process more efficient and data-driven, leveraging the power of modern technologies. 
                Our team delivered a comprehensive conjoint analysis tool, designed and developed in R programming language.
                </p>
                </h2>  
                <br></br> <br></br>

            


                <h2 className='subheader'>Key Features of the Tool: 
                <p className='description about__content-desc'>
                <ul className = 'lister'>
                    <li>Choice-based Conjoint Study Design and Analysis:</li>
                    <p className='description about__content-desc'>The tool automates the process of designing and analyzing choice-based conjoint studies, making it more efficient and user-friendly. The results are generated in real-time, providing clients with a detailed understanding of the trade-offs between different product attributes.</p>
                    <br></br> 
                    <li>Integration of Revealed and Stated Preference Models:</li>
                    <p className='description about__content-desc'>The tool integrates both revealed and stated preference models, providing a more comprehensive understanding of consumer preferences. This helps in price optimization, which is crucial in the market research and product development process.</p>
                    <br></br> 
                    <li>Machine Learning Models for Estimation of Revealed Preferences:</li>
                    <p className='description about__content-desc'>The tool utilizes machine learning models for the estimation of revealed preferences based on CRM data. This helps in making more accurate predictions about consumer preferences, which can be used for price optimization and product development.</p>
                    <br></br> 
                    <li>Price Optimization Algorithms:</li>
                    <p className='description about__content-desc'>The tool includes price optimization algorithms, which use a combination of stated and revealed preferences to provide clients with the optimal price for their products. This helps in maximizing profits and reducing costs.</p>
                    <br></br> 
                    <li>API Integration:</li>
                    <p className='description about__content-desc'>The tool is integrated with the existing services and front-end of BehaviouralStrategy LLC, providing a seamless user experience. This also enables easy access to data and results, reducing the time and effort required to analyze and interpret data.</p>

                </ul> 
                </p>
                </h2>
                <br></br> <br></br>

                <h2 className='subheader'>Outcome:    
                <p className='description about__content-desc'>
                The tool has been well-received by BehaviouralStrategy LLC and has received positive feedback from their clients. 
                The automation of the choice-based conjoint study design and analysis process has made the process more efficient and accurate, 
                providing clients with valuable insights into consumer preferences. The integration of revealed and stated preference models, 
                machine learning, and price optimization algorithms has provided a comprehensive understanding of consumer behavior, 
                which can be used for market research and product development.
                </p>
                </h2>
                <br></br> <br></br>

                <h2 className='subheader'>Conclusion:    
                <p className='description about__content-desc'>
                Our team's work on the development of a comprehensive conjoint analysis tool has demonstrated our expertise in automating complex 
                processes and utilizing the latest technologies to provide clients with valuable insights into consumer behavior. 
                The tool has been well-received by BehaviouralStrategy LLC and has received positive feedback from their clients. 
                We look forward to working on similar projects in the future and continuing to deliver cutting-edge solutions to our clients.
                </p>
                </h2>

                
            </div>
            {/* <div className='about__img'>
                <img src={aboutImg} alt="" />
            </div> */}
        </div>
    </div>
</section>

    
  )
}
export default Project_5;
